export const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const OPEN_STATUS = 'Open';
export const CLOSED_STATUS = 'Closed';

export const statusOptions = [OPEN_STATUS, CLOSED_STATUS];
const defaultOpen = {
  status: OPEN_STATUS,
  open: '09:00',
  close: '17:00',
};
const defaultClosed = {
  status: CLOSED_STATUS,
  open: '',
  close: '',
};

export const createDefaultBusinessHours = () => {
  return daysOfWeek.map((day) => {
    let hours = {
      ...defaultOpen,
      day: day,
    };
    if (day === 'Saturday' || day === 'Sunday') {
      hours = {
        ...defaultClosed,
        day: day,
      };
    }
    return hours;
  });
};
